import axios from 'axios';
import { createSignedPostRequest } from 'utils/createSignedRequestsHelpers';

export const postCreateFirestopLabels = async (
  projectId,
  firestopLabelsToCreate
) => {
  const apiPath = `firestop-documentation/project/${projectId}/create-firestop-labels`;

  const signedRequest = await createSignedPostRequest({
    apiPath,
    body: { firestopLabelsToCreate },
  });

  const response = await axios(signedRequest);

  return response.data;
};
